/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SelectBox from '@adsk/alloy-select-box';
import FormField from '@adsk/alloy-react-form-field';
import { useLocale } from '@adsk/alloy-react-helpers';
import { fieldStyle } from './styles';

const MemberFilterPanelContent = ({
  accessLevelSearchInput,
  accessLevels,
  companies,
  companySearchInput,
  isFetchingCompanies,
  isFetchingRoles,
  onAccessLevelChange,
  onChangeAccessLevelInput,
  onChangeCompanyInput,
  onChangeRoleInput,
  onChangeStatusInput,
  onCompanyChange,
  onRoleChange,
  onStatusChange,
  roleSearchInput,
  roles,
  selectedAccessLevel,
  selectedCompany,
  selectedRole,
  selectedStatus,
  status,
  statusSearchInput,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const fieldContainerRef = useRef();
  const [selectBoxStyles, setSelectBoxStyles] = useState({});

  useEffect(() => {
    setSelectBoxStyles({
      maxWidth: `${fieldContainerRef.current.offsetWidth}px`,
    });
  }, []);

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <div ref={fieldContainerRef}>
      <div css={fieldStyle}>
        <FormField
          label={T.translate('STATUS_LABEL')}
          labelVariant={FormField.LABEL_VARIANTS.TOP}
        >
          <SelectBox
            clearable
            data-testid="Status_SelectBox"
            ignoreCase
            inputValue={statusSearchInput}
            labelKey="name"
            maxMenuHeight={150}
            menuStyle={selectBoxStyles}
            onChange={onStatusChange}
            onInputChange={onChangeStatusInput}
            options={status}
            placeholder={T.translate('STATUS_PLACEHOLDER')}
            searchable
            value={selectedStatus}
            valueKey="value"
          />
        </FormField>
      </div>
      <div css={fieldStyle}>
        <FormField
          label={T.translate('COMPANY_LABEL')}
          labelVariant={FormField.LABEL_VARIANTS.TOP}
        >
          <SelectBox
            clearable
            data-testid="Company_SelectBox"
            ignoreCase
            inputValue={companySearchInput}
            isLoading={isFetchingCompanies}
            labelKey="name"
            maxMenuHeight={150}
            menuStyle={selectBoxStyles}
            onChange={onCompanyChange}
            onInputChange={onChangeCompanyInput}
            options={companies}
            placeholder={T.translate('COMPANY_PLACEHOLDER')}
            searchable
            value={selectedCompany}
            valueKey="id"
          />
        </FormField>
      </div>
      <div css={fieldStyle}>
        <FormField
          label={T.translate('ROLE_LABEL')}
          labelVariant={FormField.LABEL_VARIANTS.TOP}
        >
          <SelectBox
            clearable
            data-testid="Role_SelectBox"
            ignoreCase
            inputValue={roleSearchInput}
            isLoading={isFetchingRoles}
            labelKey="name"
            maxMenuHeight={150}
            menuStyle={selectBoxStyles}
            onChange={onRoleChange}
            onInputChange={onChangeRoleInput}
            options={roles.filter((role) => role.status === 'active')}
            placeholder={T.translate('ROLE_PLACEHOLDER')}
            searchable
            value={selectedRole}
            valueKey="id"
          />
        </FormField>
      </div>
      <div css={fieldStyle}>
        <FormField
          label={T.translate('ACCESS_LEVEL_LABEL')}
          labelVariant={FormField.LABEL_VARIANTS.TOP}
        >
          <SelectBox
            clearable
            data-testid="AccessLevel_SelectBox"
            ignoreCase
            inputValue={accessLevelSearchInput}
            labelKey="name"
            maxMenuHeight={150}
            menuStyle={selectBoxStyles}
            onChange={onAccessLevelChange}
            onInputChange={onChangeAccessLevelInput}
            options={accessLevels}
            placeholder={T.translate('ACCESS_LEVEL_PLACEHOLDER')}
            searchable
            value={selectedAccessLevel}
            valueKey="value"
          />
        </FormField>
      </div>
    </div>
  );
};

MemberFilterPanelContent.propTypes = {
  accessLevelSearchInput: PropTypes.string,
  accessLevels: PropTypes.array,
  companies: PropTypes.array,
  companySearchInput: PropTypes.string,
  isFetchingCompanies: PropTypes.bool,
  isFetchingRoles: PropTypes.bool,
  onAccessLevelChange: PropTypes.func,
  onChangeAccessLevelInput: PropTypes.func,
  onChangeCompanyInput: PropTypes.func,
  onChangeRoleInput: PropTypes.func,
  onChangeStatusInput: PropTypes.func,
  onCompanyChange: PropTypes.func,
  onRoleChange: PropTypes.func,
  onStatusChange: PropTypes.func,
  roleSearchInput: PropTypes.string,
  roles: PropTypes.array,
  selectedAccessLevel: PropTypes.object,
  selectedCompany: PropTypes.object,
  selectedRole: PropTypes.object,
  selectedStatus: PropTypes.object,
  status: PropTypes.array,
  statusSearchInput: PropTypes.string,
};

export default MemberFilterPanelContent;
